export interface GiftcardTransaction {
  ts: string;
  type: string;
  amount: string;
}

export type CheckGiftcardResult =
  | {
      status: 'ok';
      id: number;
      code: string;
      issue_ts: string;
      expire_ts: string;
      balance: string;
      currency: string;
      transactions: GiftcardTransaction[];
    }
  | { status: 'error'; error: string };

export async function checkGiftcard(code: string): Promise<CheckGiftcardResult> {
  const params = new URLSearchParams({ code: code.toUpperCase() });

  try {
    const response = await fetch(`/of2/public_services/check_giftcard?${params.toString()}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    const data = await response.json();
    return data as CheckGiftcardResult;
  } catch (error) {
    console.error('Error making the request:', error);
    return { status: 'error', error: 'check_giftcard_generic' };
  }
}
